import Content from 'gatsby-theme-core/src/components/content';
import styled from 'styled-components';

export default styled(Content)`
  h1, h2, h3 {
    color: ${({ theme }) => theme.fontColor};
  }

  h1 {
    font-size: 2.125rem;
    margin: 4rem 0 2.5rem 0;
    text-wrap: pretty;
  }

  h2 {
    font-size: 1.75rem;
    margin: 3rem 0 1.5rem 0;
    text-wrap: pretty;
  }

  h3 {
    font-size: 1.375rem;
    margin: 2rem 0 1rem 0;
    text-wrap: pretty;
  }

  h4 {
    font-size: 1.125rem;
    text-wrap: pretty;
  }

  > img {
    margin: 1rem 0;
  }
  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  a {
    font-weight: 600;
  }
`;
